<ng-container *ngIf="!isSignInPage()">
  <nav class="navbar">
    <a mat-button class="nav-button" routerLink="/">Home</a>
    <a mat-button class="nav-button" routerLink="courses">Courses</a>
    <a mat-button class="nav-button" routerLink="topics">Topics</a>
    <a mat-button class="nav-button" routerLink="problems">Problems</a>
    <a mat-button class="nav-button" routerLink="passages">Passages</a>
    <div class="flex-spacer"></div>
    <ng-container *ngIf="isAuthenticated()">
      <a mat-button (click)="logOut()">Log out</a>
    </ng-container>
  </nav>
  <app-breadcrumb></app-breadcrumb>
</ng-container>
